import type z from 'zod'

import { StrapiContentModel } from '@/src/domains/strapi/constants'
import type { StrapiQueryParams } from '@/src/domains/strapi/types'
import { fetchStrapi } from '@/src/domains/strapi/utils/fetchStrapi'

export const getStrapiAppTag = () => StrapiContentModel.APP

export async function fetchStrapiApp<Schema extends z.ZodObject<z.ZodRawShape>>({
  schema,
  query,
}: {
  schema: Schema
  query?: StrapiQueryParams
}) {
  return await fetchStrapi({
    contentType: 'app',
    query,
    schema,
    cache: {
      tags: [getStrapiAppTag()],
    },
  })
}
